(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WixDashboardSDK", [], factory);
	else if(typeof exports === 'object')
		exports["WixDashboardSDK"] = factory();
	else
		root["WixDashboardSDK"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 